import React, {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { modalSteps } from "../../../Store/simulate/actions";

import Button from "../../../Components/FormElements/Button";
import ModalFiltering from "../../../Components/FormElements/ModalFiltering";

const ModalSteps = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const modalState = useSelector((state: any) => state.simulate.policy.modalSteps);

  const handleCancelQuote = () => {
    dispatch(modalSteps(false));
    history.push("/simulaciones");

    window.digitalData.push({
      action: {
        group: "Inversión Global",
        category: "Detener",
        name: "Click",
        label: "Sí, detener",
      },
      event: "trackAction",
    });
  };

  const handleCloseModal = () => {
    dispatch(modalSteps(false));

    window.digitalData.push({
      action: {
        group: "Inversión Global",
        category: "Detener",
        name: "Click",
        label: "Seguir cotizando",
      },
      event: "trackAction",
    });
  };

  useEffect(() => {
    if (modalState) {
      window.digitalData.push({
        virtual: {
          name: "aiv:inversion-global:cotizar:detener",
        },
        event: "trackVirtual",
      });
    }
  }, [modalState]);

  return (
    <ModalFiltering className="modal-result is-midle" variant={true}>
      <h2 className="modal-result__title">¿Quieres detener la cotización?</h2>
      <div className="modal-result__desc">
        Los datos que ingresaste no se guardarán y volverás al{" "}
        <span>listado de simulaciones.</span>
      </div>
      <div className="actions">
        <Button className="actions__continue" onClick={handleCloseModal}>
          Seguir cotizando
        </Button>
        <Button
          className="is-secondary actions__cancel"
          onClick={handleCancelQuote}
        >
          Sí, detener
        </Button>
      </div>
    </ModalFiltering>
  );
};

export default ModalSteps;
